import { useState } from 'react';
import { MessageCircle, X, Send, Phone } from 'lucide-react';

export default function Chatbot() {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = '919400097300';
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent("Hello! I'm interested in booking a vehicle/stay with BlisssBus.")}`;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Chat Popover */}
      <div 
        className={`absolute bottom-[calc(100%+16px)] right-0 bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100 w-[calc(100vw-32px)] sm:w-80 max-w-xs sm:max-w-none transition-all duration-300 transform origin-bottom-right ${
          isOpen ? 'scale-100 opacity-100' : 'scale-0 opacity-0 pointer-events-none'
        }`}
      >
        <div className="bg-[#128C7E] p-4 text-white flex justify-between items-center">
          <div className="flex items-center gap-3">
            <div className="bg-white/20 p-2 rounded-full">
              <MessageCircle className="h-5 w-5 text-white" />
            </div>
            <div>
              <h3 className="font-bold text-sm">BlisssBus Helper</h3>
              <p className="text-[10px] text-green-100 opacity-90 uppercase tracking-widest">Usually replies instantly</p>
            </div>
          </div>
          <button 
            onClick={() => setIsOpen(false)}
            className="text-white/70 hover:text-white transition-colors"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <div className="p-5 bg-gray-50/50 min-h-[120px]">
          <div className="bg-white p-4 rounded-2xl rounded-tl-sm shadow-sm border border-gray-100 text-sm text-gray-700 leading-relaxed max-w-[85%]">
            Hi there! 👋 Welcome to BlisssBus. Need help finding the perfect transport or stay for your trip?
          </div>
        </div>

        <div className="p-4 bg-white border-t border-gray-100 flex flex-col gap-2">
          <a 
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full bg-[#25D366] hover:bg-[#128C7E] text-white font-bold py-3 px-4 rounded-xl text-sm flex items-center justify-center gap-2 transition-colors shadow-lg shadow-[#25D366]/20 group"
          >
            <Send className="h-4 w-4 transform group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            Chat on WhatsApp
          </a>
          <a 
            href={`tel:+${phoneNumber}`}
            className="w-full bg-gray-50 hover:bg-gray-100 text-gray-700 font-bold py-3 px-4 rounded-xl text-sm flex items-center justify-center gap-2 transition-colors border border-gray-200"
          >
            <Phone className="h-4 w-4" />
            Call Us
          </a>
        </div>
      </div>

      {/* Floating Action Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center justify-center w-14 h-14 rounded-full shadow-2xl transition-all duration-300 transform hover:scale-105 ${
          isOpen ? 'bg-red-500 text-white hover:bg-red-600' : 'bg-[#25D366] text-white hover:bg-[#128C7E] shadow-[#25D366]/30'
        }`}
      >
        {isOpen ? <X className="h-6 w-6" /> : <MessageCircle className="h-6 w-6" />}
      </button>
    </div>
  );
}
